import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "track-dashboard" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_4 = { style: {"white-space":"nowrap","position":"relative"} }
const _hoisted_5 = ["onClick", "textContent"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "lots-container" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  class: "lot-ptn"
}
const _hoisted_13 = { class: "history-chart-container" }
const _hoisted_14 = { class: "actions" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = { class: "quality-buttons" }
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = { class: "sharpening-buttons" }
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = { class: "form-actions" }

import { useWebSocketStore } from '@/store/websocket.store'
import { computed, onMounted, ref } from 'vue'
import { api } from '@/api'
import { SHARPENING_LIST, QUALITY_LIST } from '@/common/list'
import { listArt, getNameArtFromId } from '@/common/list'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Tag from 'primevue/tag'
import Button from 'primevue/button'
import Dialog from 'primevue/dialog'
import Dropdown from 'primevue/dropdown'
import InputNumber from 'primevue/inputnumber'
import ProgressSpinner from 'primevue/progressspinner'
import { useToast } from 'primevue/usetoast'
import HistoryChart from '@/components/HistoryChart.vue'

interface ITrackedArtefacts {
  id: number
  artefactId: string
  quality: number
  sharpening: string
  buyBelowPrice?: number
  sellAbovePrice?: number
  isActive: boolean
}

interface Recommendation {
  artefactId: string
  quality: number
  sharpening: string
  currentPrice: number
  averagePrice: number
  buyBelowPrice?: number
  sellAbovePrice?: number
  recommendation: string
  recommendationSeverity: 'success' | 'warning' | 'info' | 'danger'
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TrackDashboard',
  setup(__props) {

const qltMap: Record<number, string> = {
  0: '#E0E0E0',
  1: '#4CAF50',
  2: '#2196F3',
  3: '#9C27B0',
  4: '#F44336',
  5: '#FFD700'
}

const getColorQlt = (qlt: number | undefined) => qltMap[qlt ?? 0] ?? 'white'

const wsStore = useWebSocketStore()
const artefactAllMap = computed(() => wsStore.artefactAllMap)
const trackedArtefacts = ref<ITrackedArtefacts[]>([])

// Управление диалогами и формами
const toast = useToast()
const showAddDialog = ref(false)
const showDeleteDialog = ref(false)
const editingArtefact = ref(null)
const deletingArtefact = ref(null)
const saving = ref(false)
const deleting = ref(false)

// Опции для выпадающего списка артефактов
const artefactOptions = ref(listArt)

const form = ref({
  artefactId: '',
  quality: 0,
  sharpening: '0-4',
  buyBelowPrice: null,
  sellAbovePrice: null
})

const recommendations = computed(() => {
  if (!artefactAllMap.value) return []

  return trackedArtefacts.value
    .map(artefact => {
      const rows = artefactAllMap.value[artefact.artefactId]?.rows

      if (rows) {
        const map = rows.find(
          el => el.qlt === artefact.quality && el.ptn === getSharpeningLabel(artefact.sharpening)
        )

        if (map) {
          const currentPrice = Number(map.currentPrice) || 0
          const averagePrice = Number(map.averagePrice) || 0
          const currentElems = map.currentElems || []

          let recommendation = `Ничего не делать`
          let recommendationSeverity: 'success' | 'warning' | 'info' | 'danger' = 'info'
          let actionRequired = false

          if (artefact.buyBelowPrice === 0 && artefact.sellAbovePrice === 0) {
            if (currentElems.length === 0 || currentPrice >= averagePrice) {
              recommendation = 'Продавать по средней цене'
              recommendationSeverity = 'success'
              actionRequired = true
            }
          } else if (artefact.sellAbovePrice) {
            if (currentElems.length === 0 || artefact.sellAbovePrice < currentPrice) {
              recommendation = `Выставлять > ${formatPrice(
                artefact.sellAbovePrice
              )}, конкурентов ниже нет`
              recommendationSeverity = 'success'
              actionRequired = true
            }
          } else if (artefact.buyBelowPrice) {
            if (artefact.buyBelowPrice >= currentPrice) {
              recommendation = `Покупать ниже ${formatPrice(artefact.buyBelowPrice)}`
              recommendationSeverity = 'success'
              actionRequired = true
            }
          }

          return {
            id: artefact.id,
            artefactId: artefact.artefactId,
            quality: artefact.quality,
            sharpening: artefact.sharpening,
            currentPrice,
            averagePrice,
            buyBelowPrice: artefact.buyBelowPrice,
            sellAbovePrice: artefact.sellAbovePrice,
            recommendation,
            recommendationSeverity,
            actionRequired,
            totalLots: currentElems.length,
            historySalePrices: map.historySalePrices || [],
            currentElems: currentElems
          }
        }
      }

      return null
    })
    .filter(item => item !== null)
    .sort((a, b) => {
      // Сортируем по приоритету действий
      if (a.actionRequired && !b.actionRequired) return -1
      if (!a.actionRequired && b.actionRequired) return 1
      return 0
    })
})

const getSharpeningLabel = sharpening => {
  const sharpeningItem = SHARPENING_LIST.find(s => s.value === sharpening)
  return sharpeningItem ? sharpeningItem.label : `${sharpening}`
}

const getArtefactName = (artefactId: string) => {
  const artefact = listArt.find(a => a.id === artefactId)
  return artefact ? artefact.name : artefactId
}

const formatPrice = (price: number | undefined | null) => {
  if (price === undefined || price === null) return '-'
  return price.toLocaleString('ru-RU')
}

const getPriceClass = (
  currentPrice: number,
  targetPrice: number | undefined | null,
  type: 'buy' | 'sell'
) => {
  if (!targetPrice) return ''

  const isGoodDeal = type === 'buy' ? currentPrice <= targetPrice : currentPrice >= targetPrice

  return isGoodDeal ? 'good-deal' : 'normal-price'
}

const shouldBuyLot = (lot: any, recommendation: any) => {
  if (recommendation.buyBelowPrice && lot.price <= recommendation.buyBelowPrice) {
    return true
  }

  return false
}

const copyToClipboard = (text: string, type: string) => {
  navigator.clipboard
    .writeText(text)
    .then(() => {
      toast.add({
        severity: 'info',
        summary: 'Скопировано',
        detail: text,
        life: 3000
      })
    })
    .catch(err => {
      console.error('Ошибка копирования:', err)
    })
}

const loadTrackedArtefacts = async () => {
  try {
    const response = await api.get('/tracked-artefacts')
    trackedArtefacts.value = response.data
  } catch (error) {
    console.log(error)
  }
}

const saveArtefact = async () => {
  saving.value = true
  try {
    if (editingArtefact.value) {
      await api.patch(`/tracked-artefacts/${editingArtefact.value.id}`, form.value)
      toast.add({
        severity: 'success',
        summary: 'Успех',
        detail: 'Артефакт обновлен',
        life: 3000
      })
    } else {
      await api.post('/tracked-artefacts', form.value)
      toast.add({
        severity: 'success',
        summary: 'Успех',
        detail: 'Артефакт добавлен',
        life: 3000
      })
    }

    cancelForm()
    await loadTrackedArtefacts()
  } catch (error) {
    toast.add({
      severity: 'error',
      summary: 'Ошибка',
      detail: error.response?.data?.message || 'Не удалось сохранить артефакт',
      life: 3000
    })
  } finally {
    saving.value = false
  }
}

const editArtefact = artefact => {
  editingArtefact.value = artefact
  form.value = {
    artefactId: artefact.artefactId,
    quality: artefact.quality,
    sharpening: getSharpeningLabel(artefact.sharpening),
    buyBelowPrice: artefact.buyBelowPrice,
    sellAbovePrice: artefact.sellAbovePrice
  }
  showAddDialog.value = true
}

const confirmDelete = artefact => {
  deletingArtefact.value = artefact
  showDeleteDialog.value = true
}

const deleteArtefact = async () => {
  deleting.value = true
  try {
    await api.delete(`/tracked-artefacts/${deletingArtefact.value.id}`)
    toast.add({
      severity: 'success',
      summary: 'Успех',
      detail: 'Артефакт удален',
      life: 3000
    })
    showDeleteDialog.value = false
    deletingArtefact.value = null
    await loadTrackedArtefacts()
  } catch (error) {
    toast.add({
      severity: 'error',
      summary: 'Ошибка',
      detail: 'Не удалось удалить артефакт',
      life: 3000
    })
  } finally {
    deleting.value = false
  }
}

const cancelForm = () => {
  showAddDialog.value = false
  editingArtefact.value = null
  form.value = {
    artefactId: '',
    quality: 0,
    sharpening: '0-4',
    buyBelowPrice: null,
    sellAbovePrice: null
  }
}

const openAddDialog = () => {
  cancelForm() // Сбрасываем форму
  showAddDialog.value = true // Открываем диалог
}

onMounted(() => {
  loadTrackedArtefacts()
})

return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("h2", null, "Рекомендации по отслеживаемым артефактам", -1)),
      _createVNode(_unref(Button), {
        label: "Добавить артефакт",
        icon: "pi pi-plus",
        onClick: openAddDialog,
        class: "p-button-success"
      })
    ]),
    (!artefactAllMap.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_unref(ProgressSpinner), {
            style: {"width":"50px","height":"50px"},
            strokeWidth: "8"
          }),
          _cache[7] || (_cache[7] = _createElementVNode("p", null, "Загрузка данных...", -1))
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Toast),
    (artefactAllMap.value)
      ? (_openBlock(), _createBlock(_unref(DataTable), {
          key: 1,
          value: recommendations.value,
          paginator: true,
          rows: 25,
          rowsPerPageOptions: [10, 25, 50, 100],
          currentPageReportTemplate: "Показано {first} до {last} из {totalRecords} записей",
          emptyMessage: "Нет рекомендаций"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Column), {
              field: "name",
              header: "Артефакт"
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("span", {
                    onClick: ($event: any) => (copyToClipboard(getArtefactName(data.artefactId), 'name')),
                    textContent: _toDisplayString(getArtefactName(data.artefactId))
                  }, null, 8, _hoisted_5),
                  _cache[8] || (_cache[8] = _createTextVNode("  ", -1)),
                  _createElementVNode("span", {
                    style: _normalizeStyle([{"white-space":"nowrap"}, `color: ${getColorQlt(data.quality)}`])
                  }, _toDisplayString(data.sharpening), 5)
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "currentPrice",
              header: "Текущая цена"
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("span", {
                  onClick: ($event: any) => (copyToClipboard(data.currentPrice - 1, 'price')),
                  class: "clickable-price"
                }, _toDisplayString(formatPrice(data.currentPrice)), 9, _hoisted_6)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "averagePrice",
              header: "Средняя цена"
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("span", {
                  onClick: ($event: any) => (copyToClipboard(data.averagePrice - 1, 'price')),
                  class: "clickable-price"
                }, _toDisplayString(formatPrice(Number(data.averagePrice))), 9, _hoisted_7)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "buyBelowPrice",
              header: "Купить ниже"
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("span", {
                  onClick: ($event: any) => (copyToClipboard(data.buyBelowPrice - 1, 'price')),
                  class: _normalizeClass([getPriceClass(data.currentPrice, data.buyBelowPrice, 'buy'), "clickable-price"])
                }, _toDisplayString(formatPrice(data.buyBelowPrice)), 11, _hoisted_8)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "sellAbovePrice",
              header: "Продать выше"
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("span", {
                  onClick: ($event: any) => (copyToClipboard(data.sellAbovePrice - 1, 'price')),
                  class: _normalizeClass([getPriceClass(data.currentPrice, data.sellAbovePrice, 'sell'), "clickable-price"])
                }, _toDisplayString(formatPrice(data.sellAbovePrice)), 11, _hoisted_9)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "recommendation",
              header: "Рекомендация"
            }, {
              body: _withCtx(({ data }) => [
                _createVNode(_unref(Tag), {
                  value: data.recommendation,
                  severity: data.recommendationSeverity
                }, null, 8, ["value", "severity"])
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "currentElems",
              header: "Лоты"
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("div", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.currentElems, (lot, index) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: index,
                      class: _normalizeClass(["lot-item", {
                  'lot-to-buy': shouldBuyLot(lot, data),
                  'lot-normal': !shouldBuyLot(lot, data)
                }])
                    }, [
                      _createElementVNode("span", {
                        onClick: ($event: any) => (copyToClipboard(lot.price - 1, 'price')),
                        class: "lot-price clickable-lot-price"
                      }, _toDisplayString(formatPrice(lot.price)), 9, _hoisted_11),
                      (lot.additionalInfo?.ptn !== undefined)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, "-" + _toDisplayString(lot.additionalInfo.ptn), 1))
                        : _createCommentVNode("", true)
                    ], 2))
                  }), 128))
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "historySalePrices",
              header: "График продаж"
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("small", null, _toDisplayString(data.historySalePrices?.length || 0) + " продаж", 1),
                  _createVNode(HistoryChart, {
                    historySalePrices: data.historySalePrices || [],
                    "sale-price": data.averagePrice
                  }, null, 8, ["historySalePrices", "sale-price"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { header: "Действия" }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("div", _hoisted_14, [
                  _withDirectives(_createVNode(_unref(Button), {
                    icon: "pi pi-pencil",
                    class: "p-button-rounded p-button-text p-button-info",
                    onClick: ($event: any) => (editArtefact(data))
                  }, null, 8, ["onClick"]), [
                    [_directive_tooltip, 'Редактировать']
                  ]),
                  _withDirectives(_createVNode(_unref(Button), {
                    icon: "pi pi-trash",
                    class: "p-button-rounded p-button-text p-button-danger",
                    onClick: ($event: any) => (confirmDelete(data))
                  }, null, 8, ["onClick"]), [
                    [_directive_tooltip, 'Удалить']
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"]))
      : _createCommentVNode("", true),
    _createVNode(_unref(Dialog), {
      visible: showAddDialog.value,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((showAddDialog).value = $event)),
      header: editingArtefact.value ? 'Редактировать артефакт' : 'Добавить артефакт',
      modal: true,
      style: { width: '900px' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _withModifiers(saveArtefact, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_15, [
            _cache[9] || (_cache[9] = _createElementVNode("label", { for: "artefactId" }, "Артефакт", -1)),
            _createVNode(_unref(Dropdown), {
              id: "artefactId",
              modelValue: form.value.artefactId,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.artefactId) = $event)),
              options: artefactOptions.value,
              optionLabel: "name",
              optionValue: "id",
              placeholder: "Выберите артефакт",
              required: "",
              editable: ""
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _cache[10] || (_cache[10] = _createElementVNode("label", { for: "quality" }, "Качество", -1)),
            _createElementVNode("div", _hoisted_17, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(QUALITY_LIST), (quality) => {
                return (_openBlock(), _createBlock(_unref(Button), {
                  key: quality.value,
                  label: quality.label,
                  style: _normalizeStyle({ backgroundColor: quality.color }),
                  class: _normalizeClass(["quality-btn", { active: form.value.quality === quality.value }]),
                  onClick: ($event: any) => (form.value.quality = quality.value)
                }, null, 8, ["label", "style", "class", "onClick"]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _cache[11] || (_cache[11] = _createElementVNode("label", { for: "sharpening" }, "Заточка", -1)),
            _createElementVNode("div", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(SHARPENING_LIST), (sharpening) => {
                return (_openBlock(), _createBlock(_unref(Button), {
                  key: sharpening.value,
                  label: sharpening.label,
                  style: _normalizeStyle({
                backgroundColor: sharpening.color,
                borderColor: sharpening.color,
                color: 'black'
              }),
                  class: _normalizeClass(["sharpening-btn", { active: form.value.sharpening === sharpening.label }]),
                  onClick: ($event: any) => (form.value.sharpening = sharpening.label)
                }, null, 8, ["label", "style", "class", "onClick"]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _cache[12] || (_cache[12] = _createElementVNode("label", { for: "buyBelowPrice" }, "Цена покупки (ниже)", -1)),
            _createVNode(_unref(InputNumber), {
              id: "buyBelowPrice",
              modelValue: form.value.buyBelowPrice,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.buyBelowPrice) = $event)),
              min: 0
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _cache[13] || (_cache[13] = _createElementVNode("label", { for: "sellAbovePrice" }, "Цена продажи (выше)", -1)),
            _createVNode(_unref(InputNumber), {
              id: "sellAbovePrice",
              modelValue: form.value.sellAbovePrice,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.sellAbovePrice) = $event)),
              min: 0
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_unref(Button), {
              label: "Отмена",
              icon: "pi pi-times",
              class: "p-button-text",
              onClick: cancelForm
            }),
            _createVNode(_unref(Button), {
              label: editingArtefact.value ? 'Сохранить' : 'Добавить',
              icon: "pi pi-check",
              type: "submit",
              loading: saving.value
            }, null, 8, ["label", "loading"])
          ])
        ], 32)
      ]),
      _: 1
    }, 8, ["visible", "header"]),
    _createVNode(_unref(Dialog), {
      visible: showDeleteDialog.value,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((showDeleteDialog).value = $event)),
      header: "Подтверждение удаления",
      modal: true,
      style: { width: '400px' }
    }, {
      footer: _withCtx(() => [
        _createVNode(_unref(Button), {
          label: "Отмена",
          icon: "pi pi-times",
          class: "p-button-text",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (showDeleteDialog.value = false))
        }),
        _createVNode(_unref(Button), {
          label: "Удалить",
          icon: "pi pi-trash",
          class: "p-button-danger",
          onClick: deleteArtefact,
          loading: deleting.value
        }, null, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _cache[14] || (_cache[14] = _createElementVNode("p", null, "Вы уверены, что хотите удалить этот артефакт из отслеживаемых?", -1))
      ]),
      _: 1,
      __: [14]
    }, 8, ["visible"])
  ]))
}
}

})